module.exports = __webpack_public_path__ + "static/img/icon_two_months.be19423e.png";